module.exports = __webpack_public_path__ + "static/media/banner.038c14ce.png";